import { UIText2 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as style from './style.css';

export interface INavigationLink {
  href: string;
  text: string;
}

export interface INavigationLinksProps {
  activeHref: string;
  links: INavigationLink[];
  navigate: (event: React.MouseEvent<HTMLAnchorElement>, href: string) => void;
}

export const NavigationLinks: React.FC<INavigationLinksProps> = ({ activeHref, links, navigate }) => {
  return (
    <ul className={style['links']}>
      {links.map(({ href, text }) => (
        <li key={text} className={cn(style['link-item'], activeHref === href && style['active'])}>
          <a href={href} onClick={event => navigate(event, href)}>
            <UIText2
              color={activeHref === href ? 'primary_100' : 'black_100'}
              fontWeight={activeHref === href ? '700' : '400'}
            >
              {text}
            </UIText2>
          </a>
        </li>
      ))}
    </ul>
  );
};
